import ReactSelect from "react-select";

export const SelectInput = ({ options, value, onChange, placeholder, isDisabled = false, isRtl = true }) => {
  return (
    <ReactSelect
      className="border-primary border-[1px] rounded-md"
      options={options}
      value={value}
      onChange={onChange}
      hideSelectedOptions={false}
      closeMenuOnSelect={true}
      isRtl={isRtl}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
  );
};